// 定义支持的链和对应的交易费用
export const chainTransFee = {
  BSC: 0.0005,      // BSC链交易费用
  ETH: 0.0003,      // 以太坊主网交易费用
  BASE: 0.0003,      // BASE链交易费用
}

// 获取当前链的交易费用
export const getTransFee = (chainId: number): number => {
  switch (chainId) {
    case 56:        // BSC
    case 97:        // BSC测试链
      return chainTransFee.BSC
    case 1:         // ETH
      return chainTransFee.ETH
    case 8453:      // BASE
      return chainTransFee.BASE
    default:
      return 0.0001  // 默认费用
  }
}

export const TransTimes = 2 // 转账次数
export const serviceFeeReceivingAddress = '0x65bc60ceea4a1d5e3933372befa70e382cc67718' // 服务费接收地址